export const environment = {
  production: false,
  urlCon: "https://api-conecta.segurosbolivar.com/prod/",
  apikeyCon: "Qi8Tyqm78257XH4EgwJS83l9Dirfbe9F10SYyLKT",
  urlRedirectNF: "https://www.segurosbolivar.com/directorio-seguros-personas/not_found"
};
